import { unit } from '@ant-design/cssinjs';
import { clearFix, textEllipsis } from '../../style';
const genListStyle = token => {
  const {
    componentCls,
    antCls,
    iconCls,
    fontSize,
    lineHeight,
    calc
  } = token;
  const itemCls = "".concat(componentCls, "-list-item");
  const actionsCls = "".concat(itemCls, "-actions");
  const actionCls = "".concat(itemCls, "-action");
  const listItemHeightSM = token.fontHeightSM;
  return {
    ["".concat(componentCls, "-wrapper")]: {
      ["".concat(componentCls, "-list")]: Object.assign(Object.assign({}, clearFix()), {
        lineHeight: token.lineHeight,
        [itemCls]: {
          position: 'relative',
          height: calc(token.lineHeight).mul(fontSize).equal(),
          marginTop: token.marginXS,
          fontSize,
          display: 'flex',
          alignItems: 'center',
          transition: "background-color ".concat(token.motionDurationSlow),
          '&:hover': {
            backgroundColor: token.controlItemBgHover
          },
          ["".concat(itemCls, "-name")]: Object.assign(Object.assign({}, textEllipsis), {
            padding: "0 ".concat(unit(token.paddingXS)),
            lineHeight,
            flex: 'auto',
            transition: "all ".concat(token.motionDurationSlow)
          }),
          [actionsCls]: {
            whiteSpace: 'nowrap',
            [actionCls]: {
              opacity: 0
            },
            [iconCls]: {
              color: token.actionsColor,
              transition: "all ".concat(token.motionDurationSlow)
            },
            ["\n              ".concat(actionCls, ":focus-visible,\n              &.picture ").concat(actionCls, "\n            ")]: {
              opacity: 1
            },
            ["".concat(actionCls).concat(antCls, "-btn")]: {
              height: listItemHeightSM,
              border: 0,
              lineHeight: 1
            }
          },
          ["".concat(componentCls, "-icon ").concat(iconCls)]: {
            color: token.colorTextDescription,
            fontSize
          },
          ["".concat(itemCls, "-progress")]: {
            position: 'absolute',
            bottom: token.calc(token.uploadProgressOffset).mul(-1).equal(),
            width: '100%',
            paddingInlineStart: calc(fontSize).add(token.paddingXS).equal(),
            fontSize,
            lineHeight: 0,
            pointerEvents: 'none',
            '> div': {
              margin: 0
            }
          }
        },
        ["".concat(itemCls, ":hover ").concat(actionCls)]: {
          opacity: 1
        },
        ["".concat(itemCls, "-error")]: {
          color: token.colorError,
          ["".concat(itemCls, "-name, ").concat(componentCls, "-icon ").concat(iconCls)]: {
            color: token.colorError
          },
          [actionsCls]: {
            ["".concat(iconCls, ", ").concat(iconCls, ":hover")]: {
              color: token.colorError
            },
            [actionCls]: {
              opacity: 1
            }
          }
        },
        ["".concat(componentCls, "-list-item-container")]: {
          transition: "opacity ".concat(token.motionDurationSlow, ", height ").concat(token.motionDurationSlow),
          // For smooth removing animation
          '&::before': {
            display: 'table',
            width: 0,
            height: 0,
            content: '""'
          }
        }
      })
    }
  };
};
export default genListStyle;